/**
 * Application Configuration
 * Loads environment-specific settings based on NODE_ENV
 * Simplified version without environment-specific overrides
 */

const config = {
  app: {
    name: process.env.REACT_APP_NAME || "Prism Monitor",
    version: process.env.REACT_APP_VERSION || "1.0.0",
    environment: process.env.NODE_ENV || "development",
    buildTime: new Date().toISOString(),
    subDirectory: process.env.REACT_APP_SUB_DIRECTORY || "",
    features: {
      autoRefresh: {
        dashboard: parseInt(process.env.REACT_APP_AUTO_REFRESH_DASHBOARD) || 15000,
        heartbeat: parseInt(process.env.REACT_APP_AUTO_REFRESH_HEARTBEAT) || 15000,
        reportResults: parseInt(process.env.REACT_APP_AUTO_REFRESH_REPORT_RESULTS) || 30000,
        notifications: parseInt(process.env.REACT_APP_AUTO_REFRESH_NOTIFICATIONS) || 30000
      },
      timeZone: {
        default: process.env.REACT_APP_TIMEZONE_DEFAULT || "local",
        utcOffset: process.env.REACT_APP_TIMEZONE_UTC_OFFSET || "+05:30",
        allowSwitch: process.env.REACT_APP_TIMEZONE_ALLOW_SWITCH === "true" || true
      },
      notifications: {
        autoHideDuration: parseInt(process.env.REACT_APP_NOTIFICATIONS_AUTO_HIDE_DURATION) || 5000,
        showDesktopNotifications: process.env.REACT_APP_NOTIFICATIONS_SHOW_DESKTOP === "true" || false
      }
    }
  },
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/EmailDashboard-CAS",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
    retryAttempts: parseInt(process.env.REACT_APP_API_RETRY_ATTEMPTS) || 3
  },
  msal: {
    auth: {
      clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
      authority: process.env.REACT_APP_MICROSOFT_AUTHORITY || "https://login.microsoftonline.com/common",
      redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URI || window.location.origin,
      navigateToLoginRequestUrl: process.env.REACT_APP_MICROSOFT_NAVIGATE_TO_LOGIN === "true" || false,
      postLogoutRedirectUri: process.env.REACT_APP_MICROSOFT_POST_LOGOUT_REDIRECT_URI || window.location.origin,
      mainWindowRedirectUri: process.env.REACT_APP_MICROSOFT_MAIN_WINDOW_REDIRECT_URI || window.location.origin,
      forceLogoutURL: process.env.REACT_APP_MICROSOFT_FORCE_LOGOUT_URL || window.location.origin
    },
    cache: {
      cacheLocation: process.env.REACT_APP_MICROSOFT_CACHE_LOCATION || "sessionStorage",
      storeAuthStateInCookie: process.env.REACT_APP_MICROSOFT_STORE_AUTH_STATE_IN_COOKIE === "true" || false
    },
    scopes: process.env.REACT_APP_MICROSOFT_SCOPES ? 
      process.env.REACT_APP_MICROSOFT_SCOPES.split(",").map(scope => scope.trim()) : 
      ["User.Read", "User.ReadBasic.All", "openid", "profile", "email"]
  }
};

// Make config globally available (for backward compatibility)
window.ADI_CONFIG = config;

export default config;